<template>
  <div>
    <!-- 当设备未连接时， 除了模块型号、运营商、支持制式、IMSI、IMEI、ICCID是显示相应数据的，其他都显示unknow未知-->
    <table>
      <tr>
        <th>{{ $t("lang.particulars.wan3g1IP") }}</th>
        <td v-if="isAllShow && wanData.dsIp">{{ wanData.dsIp }}</td>
        <td v-else-if="isAllShow">N/A</td>
        <td v-else>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.wan3g1gateway") }}</th>
        <td v-if="isAllShow && wanData.dsGateway">{{ wanData.dsGateway }}</td>
        <td v-else-if="isAllShow">N/A</td>
        <td v-else>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr v-if="wanData.dsIpv6">
        <th>{{ $t("lang.particulars.wan3g1IPV6") }}</th>
        <td>
          <span
            style="display:block;"
            v-for="item in wanData.dsIpv6"
            :key="item"
            >{{ item }}</span
          >
        </td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.wan3g1NonContiguousSubnetMask") }}</th>
        <td v-if="isAllShow && wanData.dsNetmask">{{ wanData.dsNetmask }}</td>
        <td v-else-if="isAllShow">N/A</td>
        <td v-else>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.wan3g1NETWORK") }}</th>
        <td v-if="isAllShow && wanData.dsProto == 0">PPP</td>
        <td v-else-if="isAllShow && wanData.dsProto == 1">DHCP</td>
        <td v-else-if="isAllShow && wanData.dsProto == 2">
          {{ $t("lang.particulars.addressStrings") }}
        </td>
        <td v-else-if="isAllShow">N/A</td>
        <td v-else>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.wan3g1DNS1") }}</th>
        <td v-if="isAllShow && wanData.dsDns">
          {{ wanData.dsDns.split(",")[0] }}
        </td>
        <td v-else-if="isAllShow">N/A</td>
        <td v-else>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.wan3g1DNS2") }}</th>
        <td v-if="isAllShow && wanData.dsDns">
          {{ wanData.dsDns.split(",")[1] }}
        </td>
        <td v-else-if="isAllShow">N/A</td>
        <td v-else>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr>
        <!-- 模块型号 -->
        <th>{{ $t("lang.particulars.MODULE_FILE_SUFFIX") }}</th>
        <td v-if="wanData.model">{{ wanData.model }}</td>
        <td v-else>N/A</td>
        <!-- 运营商 -->
        <th>{{ $t("lang.particulars.Operator") }}</th>
        <td v-if="wanData.Operator">{{ wanData.Operator }}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <!-- 支持制式 -->
        <th>{{ $t("lang.particulars.supported") }}</th>
        <td v-if="wanData.supported">{{ wanData.supported }}</td>
        <td v-else>N/A</td>
        <th>{{ $t("lang.particulars.IMSI") }}</th>
        <td v-if="wanData.IMSI">{{ wanData.IMSI }}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.IMEI") }}</th>
        <td v-if="wanData.IMEI">{{ wanData.IMEI }}</td>
        <td v-else>N/A</td>
        <th>{{ $t("lang.particulars.ICCID") }}</th>
        <td v-if="wanData.ICCID">{{ wanData.ICCID }}</td>
        <td v-else>N/A</td>
      </tr>
      <tr v-if="isAllShow && wanData.deviceNetStatusList">
        <th>{{ $t("lang.particulars.current") }}</th>
        <td v-if="wanData.deviceNetStatusList.tfNettype !== ''">
          {{ wanData.deviceNetStatusList.tfNettype }}
        </td>
        <td v-else>N/A</td>
        <th>{{ $t("lang.particulars.SignalStrengths") }}</th>
        <td v-if="wanData.deviceNetStatusList.tfRssi !== ''">
          {{ wanData.deviceNetStatusList.tfRssi }}
        </td>
        <td v-else>N/A</td>
      </tr>
      <tr v-else>
        <th>{{ $t("lang.particulars.current") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.SignalStrengths") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr v-if="isAllShow && wanData.deviceNetStatusList">
        <th>{{ $t("lang.particulars.SIM") }}</th>
        <td v-if="wanData.deviceNetStatusList.tfUsim == 0">
          {{
            $t("lang.particulars.refreshHaves") +
              `(${
                wanData.deviceNetStatusList.tfSimnum === 0 ? "SIM1" : "SIM2"
              })`
          }}
        </td>
        <td v-else-if="wanData.deviceNetStatusList.tfUsim == 1">
          {{ $t("lang.particulars.info_normal_color") }}
        </td>
        <td v-else-if="wanData.deviceNetStatusList.tfUsim == 2">
          {{ $t("lang.particulars.package_pin") }}
          {{ wanData.deviceNetStatusList.tfSimnum === 0 ? "SIM1" : "SIM2" }}
        </td>
        <td v-else-if="wanData.deviceNetStatusList.tfUsim == 3">
          {{ $t("lang.particulars.IMEI_CODE_LEN") }}
          {{ wanData.deviceNetStatusList.tfSimnum === 0 ? "SIM1" : "SIM2" }}
        </td>
        <td v-else-if="wanData.deviceNetStatusList.tfUsim == 4">
          {{ $t("lang.particulars.aac_card_type") }}
          {{ wanData.deviceNetStatusList.tfSimnum === 0 ? "SIM1" : "SIM2" }}
        </td>
        <td v-else-if="wanData.deviceNetStatusList.tfUsim == 5">
          {{ $t("lang.particulars.unknown") }}
        </td>
        <td v-else>N/A</td>
        <th>{{ $t("lang.particulars.wan3g1NETWORK_FAUX_QUEUE") }}</th>
        <td v-if="wanData.deviceNetStatusList.tfDuration !== ''">
          {{ computeDate(wanData.deviceNetStatusList.tfDuration) }}
        </td>
        <td v-else>N/A</td>
      </tr>
      <tr v-else>
        <th>{{ $t("lang.particulars.SIM") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.wan3g1NETWORK_FAUX_QUEUE") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.wan3g1Connection") }}</th>
        <td v-if="isAllShow && wanData.dsIp">
          {{ $t("lang.particulars.connected") }}
        </td>
        <td v-else-if="isAllShow">{{ $t("lang.particulars.disOpened") }}</td>
        <td v-else>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.wan3g1UpdateTime") }}</th>
        <td v-if="isAllShow && wanData.dsUpdate">{{ wanData.dsUpdate }}</td>
        <td v-else>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <!-- <tr v-if="deviceSmartcardTag">
        <th v-if="deviceSmartcardTag">操作</th>
        <td v-if="deviceSmartcardTag">
          
        </td>
      </tr>-->
    </table>
  </div>
</template>
<script>
import { SecondToDate } from "@/utils/Date.js";
export default {
  props: ["wanData", "deviceIsconnected", "deviceSmartcardTag"],
  data() {
    return {
      IMEI: "",
      IMSI: "",
      ICCID: "",
      // 模块型号，支持制式，运营商
      model: "",
      supported: "",
      Operator: "",
      isAllShow: true,
    };
  },
  watch: {
    wanData: {
      immediate: true,
      handler() {
        if (this.wanData && this.deviceIsconnected == 3) {
          this.isAllShow = true;
        } else {
          this.isAllShow = false;
        }
        if (this.wanData.dsIpv6) {
          this.wanData.dsIpv6 = this.wanData.dsIpv6.split("#");
        }
      },
    },
  },
  methods: {
    //计算秒数
    computeDate(msd) {
      return SecondToDate(msd);
    },
    // switchRecord(e) {
    //   this.$refs['switchCard'].show = true
    // }
  },
};
</script>
<style scoped src="./particulars.css"></style>
